/**
 * 专业质检svg
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/7
 */
import React from 'react';

const Check = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-check">
    <path d="M265.106 743.982h198.842v33.14h-198.842v-33.14z"/>
    <path d="M265.106 578.281h198.842v33.14h-198.842v-33.14z"/>
    <path d="M265.106 412.58h397.682v33.14h-397.682v-33.14z"/>
    <path d="M265.106 246.879h397.682v33.14h-397.682v-33.14z"/>
    <path d="M777.121 66.265h-629.663c-28.17 0-48.054 38.112-48.054 64.624v762.224c0 28.17 19.884 34.797 48.054 34.797h316.489v-33.14h-316.489c-9.942 0-14.913 8.285-14.913-1.657v-762.224c0-9.942 4.971-31.483 14.913-31.483h629.663c9.942 0 18.227 23.198 18.227 31.483v299.918h33.14v-299.918c0-26.511-24.854-64.624-51.367-64.624z"/>
    <path d="M700.899 884.827c-39.769 0-77.879-14.913-106.048-43.083-57.996-57.996-57.996-152.445 0-210.439s152.445-57.996 210.439 0v0 0c28.17 28.17 43.083 66.281 43.083 106.048s-14.913 77.879-43.083 106.048c-26.511 26.511-64.624 41.425-104.391 41.425zM700.899 619.706c-29.826 0-59.652 11.599-81.193 33.14-44.739 44.739-44.739 119.306 0 164.044 21.54 21.54 51.367 34.797 81.193 34.797s59.652-11.599 81.193-34.797 34.797-51.367 34.797-81.193-11.599-59.652-34.797-81.193v0c-21.54-23.198-51.367-34.797-81.193-34.797z"/>
    <path d="M924.86 934.731l-23.434 23.434-117.167-117.167 23.434-23.434 117.167 117.167z"/>
  </svg>
};

export default Check


// WEBPACK FOOTER //
// ./src/svgs/check.js